exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".about{padding:3rem 6rem 0 6rem;border-radius:4px;background-color:#fff}.about .disclaimer{margin-top:44px;padding:65px 0 15px 0}@media(max-width: 575px){.about .disclaimer{margin-top:1px;padding-top:0}}.about .disclaimer p{font-size:14px;font-weight:500;line-height:17px;text-align:center}@media(max-width: 575px){.about .disclaimer p{text-align:left}}@media(max-width: 575px){.about{padding:1.5rem 1.5rem 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/About/About.scss
// module id = 7756
// module chunks = 13